import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { records as jobsRecords } from '@saucelabs/sl-module-jobs';
import { JobCard } from '@saucelabs/sl-component-job-card';
import { GroupByDate } from '@saucelabs/sl-component-group-by-date';

import SeeAllButton from './SeeAllButton';
import RenderResults from './RenderResults';
import { JOB_TYPES, NAVIGATION_EVENTS, trackEvent } from './../tracking';
import ListStyles from './List.styles';

const ManualJobs = ({ showSeeAllButton, jobs }) => {
  useEffect(() => {
    trackEvent(NAVIGATION_EVENTS.VIEW_JOB_LIST, { state: 'With Jobs State' });
  }, []);
  return (
    <div className={ListStyles.list}>
      <RenderResults size={jobs.size}>
        <GroupByDate datePath={(item) => item.props.job.get('creation_time')}>
          {jobs.map((job) => (
            <JobCard
              key={job.id}
              job={job}
              onClick={() => trackEvent(
                NAVIGATION_EVENTS.VIEW_JOB_DETAILS,
                { type: JOB_TYPES.MANUAL },
              )}
            />
          ))}
        </GroupByDate>
      </RenderResults>
      {showSeeAllButton && <SeeAllButton />}
    </div>
  );
};

ManualJobs.propTypes = {
  jobs: ImmutablePropTypes.listOf(
    ImmutablePropTypes.recordOf(jobsRecords.JobRecordClass).isRequired,
  ).isRequired,
  showSeeAllButton: PropTypes.bool,
};

ManualJobs.defaultProps = {
  showSeeAllButton: true,
};

export default ManualJobs;
